export default __webpack_public_path__ + "static/media/logo-w.58713bb9.png";